import { render, staticRenderFns } from "./tmsTablecoms.vue?vue&type=template&id=66872014&"
import script from "./tmsTablecoms.vue?vue&type=script&lang=js&"
export * from "./tmsTablecoms.vue?vue&type=script&lang=js&"
import style0 from "./tmsTablecoms.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports